<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1">
            <div class="row">
              <div class="col-md-12 mb-1">
                <label>Grupo (opcional)</label>
                <v-select
                  v-model="thisGroup.group_father"
                  :options="groups"
                  :reduce="(groups) => groups.id"
                  :label="'name'"
                ></v-select>
              </div>
              <div class="col-md-12 mb-1">
                <label>Nome</label>
                <input
                  v-model="thisGroup.name"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="block text-right mb-1">
              <router-link to="/groups" class="btn btn-back">
                <i class="fa fa-arrow-left"></i> Voltar
              </router-link>
              <a class="btn btn-add ml-1" @click="save">
                Salvar
                <i class="fa fa-save"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      groups: [],
      thisGroup: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "groups";

      if (self.thisGroup.id) {
        api += "/" + self.thisGroup.id;
        self.thisGroup._method = "PUT";
      }

      axios
        .post(api, self.thisGroup)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/groups");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getGroups: function () {
      const self = this;
      let api = self.$store.state.api + "groups/";

      axios
        .get(api)
        .then((response) => {
          self.groups = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getThisGroup: function (id) {
      const self = this;
      let api = self.$store.state.api + "groups/" + id;

      axios
        .get(api)
        .then((response) => {
          self.thisGroup = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getGroups();

    if (id) {
      self.getThisGroup(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>